require([
  //load root dependencies from here
  "pym",
  "jquery",
  "lib/bootstrap/dist/js/bootstrap.min",
 

], function(pym) {

  var child = new pym.Child();

  setInterval(child.sendHeight.bind(child), 500);
  
});

define("main", function(){});

